import { LbEventPhase, LbEventSubType, LbEventType, VarStatus } from '@uefacom-newdev/liveblog-integration-react';

export type LbIcon = {
  iconName: string;
  iconColor?: string;
};

export const matchEventIcons: {
  [key in LbEventType]?: LbIcon & { [key in LbEventSubType | LbEventPhase]?: LbIcon };
} = {
  [LbEventType.YELLOW_CARD]: {
    iconName: 'football-card-single-card',
    iconColor: 'support-05',
  },
  [LbEventType.RED_CARD]: {
    iconName: 'football-card-single-card',
    iconColor: 'support-04',
  },
  [LbEventType.RED_YELLOW_CARD]: {
    iconName: 'football-card-yellow-to-red-color',
  },
  [LbEventType.GOAL]: {
    iconName: 'football-goal',
    [LbEventSubType.OWN]: {
      iconName: 'football-goal',
      iconColor: 'support-04',
    },
    [LbEventSubType.PENALTY]: {
      iconName: 'football-goal-penalty-color',
    },
    [LbEventSubType.MISSED]: {
      iconName: 'football-goal-penalty-missed-color',
    },
  },
  [LbEventType.SUBSTITUTION]: {
    iconName: 'football-substitution-both-color',
  },
  [LbEventType.PENALTY]: {
    iconName: 'football-goal-penalty-missed-color',
    [LbEventSubType.SCORED]: {
      iconName: 'football-goal-penalty-color',
    },
  },
  [LbEventType.START_PHASE]: {
    iconName: 'football-time-start',

    [LbEventPhase.PENALTY]: {
      iconName: 'football-time-wistle',
    },
    [LbEventPhase.EXTRA_TIME_FIRST_HALF]: {
      iconName: 'football-time-extra-time-color',
    },
  },
  [LbEventType.END_PHASE]: {
    iconName: 'football-time-end-color',
    [LbEventPhase.FIRST_HALF]: {
      iconName: 'football-time-extra-time-color',
    },
  },
  [LbEventType.PAUSE]: {
    iconName: 'football-time-break',
  },
  [LbEventType.RESUME]: {
    iconName: 'football-time-wistle',
  },
  [LbEventType.CHANGE_PHASE]: {
    iconName: 'football-penalty-shootout',
  },
  [LbEventType.INJURY_TIME]: {
    iconName: 'football-time-additional-time-color',
  },
};

export const varIcons: { [key in VarStatus]?: string } = {
  [VarStatus.OFFICIAL_REVIEW]: 'support-03',
  [VarStatus.CONFIRMED]: 'support-01',
  [VarStatus.CHANGED]: 'support-01',
};
